module.exports = __webpack_public_path__ + "static/media/list-ul.55c5eebe.svg";